// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__25XyB","emails":"CreateEditClinics_emails__m-A72","emailTagLabel":"CreateEditClinics_emailTagLabel__1Vj3u"};